import { call, put, takeLatest, delay } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import actions, { Types } from '~/store/ducks/anticipations';
import snackbar from '../ducks/snackbar';
import api from '~/services/api';

function* loadAvailableAnticipations({ partner }) {
  try {
    const { data } = yield call(
      api.get,
      `/v1/partners/${partner}/anticipation`
    );
    yield put(
      actions.loadAvailableAnticipationsSuccess(data.total, data.entries)
    );
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* loadAnticipations({ partner }) {
  try {
    const { data } = yield call(
      api.get,
      `/v1/anticipations/partners/${partner}`
    );
    yield put(actions.loadAnticipationsSuccess(data || []));
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* requestAnticipation({ partner, data }) {
  try {
    yield call(api.post, `/v1/partners/${partner}/anticipation`, data);

    yield put(actions.loadAnticipations(partner));

    yield put(push('/anticipations'));

    yield put(
      snackbar.showSnackbar('success', 'anticipation.request.success', 'check')
    );

    yield delay(5000);
    yield put(snackbar.hideSnackbar());
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

const sagas = [
  takeLatest(Types.LOAD_AVAILABLE_ANTICIPATIONS, loadAvailableAnticipations),
  takeLatest(Types.LOAD_ANTICIPATIONS, loadAnticipations),
  takeLatest(Types.REQUEST_ANTICIPATION, requestAnticipation)
];

export default sagas;
